var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.renderless
    ? _c("div", { staticClass: "lab-card" }, [
        _c(
          "div",
          { staticClass: "lab-card__header" },
          [
            _c("div", { staticClass: "lab-card__name" }, [
              _vm._v(_vm._s(_vm.labName))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lab-card__tag" }, [
              _vm._v(_vm._s(_vm.labPlace))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lab-card__rating" },
              [_c("rating-stars", { attrs: { rating: _vm.rating } })],
              1
            ),
            _vm._v(" "),
            [_vm._t("edit-button")]
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lab-card__body" }, [
          _c(
            "div",
            { staticClass: "row no-gutters" },
            _vm._l(_vm.equipmentSlots, function(equipment) {
              return _c(
                "div",
                { key: equipment.ID, staticClass: "col-sm-6 col-3" },
                [
                  _c("lab-card-equipment", {
                    attrs: {
                      "for-who-id": _vm.forWho.ID,
                      "cooking-type-id": _vm.equipments.ID,
                      "equipment-slot": equipment,
                      "equipment-selected": _vm.checkEquipment(equipment)
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lab-card__footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-block btn-main",
              on: { click: _vm.openRecommTab }
            },
            [_vm._v("Улучшить лабораторию")]
          ),
          _vm._v(" "),
          _vm.catalogLink
            ? _c(
                "a",
                {
                  staticClass: "btn btn-sm btn-outline-main btn-block",
                  attrs: { href: _vm.catalogLink }
                },
                [_vm._v("Подобрать кофе")]
              )
            : _vm._e()
        ])
      ])
    : _c(
        "div",
        [
          _vm._t("default", null, null, {
            labName: _vm.labName,
            catalogLink: _vm.catalogLink,
            openRecommTab: _vm.openRecommTab,
            labPlace: _vm.labPlace,
            rating: _vm.rating,
            equipmentSlots: _vm.equipmentSlots,
            getEquipmentRating: _vm.getEquipmentRating,
            checkEquipment: _vm.checkEquipment
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }